import { store } from "../store";
import { BifrostBackendApi, BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const tenantConfig = appConfig.tenantConfig;

const isNestBackend = () => store.getters.featureToggles && store.getters.featureToggles.useNestOrderPaymentFlow;

const createHeader = function({ authToken }) {
	const headers = {};

	if (authToken) {
		headers.Authorization = authToken;
	}

	return headers;
};

const getShopsApi = (useNewShopsData = false) => {
	return useNewShopsData ? BifrostBackendNestApi : BifrostBackendApi;
};

const ShopsProvider = {
	findAllByChannel(
		authToken,
		onlyActive = true,
		useNewShopsData = isNestBackend(),
		showSecretRestaurants = undefined
	) {
		const queryData = {
			tenantId: tenantConfig.tenantId,
			onlyActive,
			channel: appConfig.channelAlias(),
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			showSecretRestaurants
		};
		const url = useNewShopsData ? "/intusr/shops" : "/shops";
		return getShopsApi(useNewShopsData).get(url, {
			headers: {
				...createHeader({ authToken }),
				["X-TenantId"]: tenantConfig.tenantId
			},
			params: queryData
		});
	},

	findAll(
		authToken,
		onlyActive = true,
		useNewShopsData = isNestBackend(),
		showSecretRestaurants = undefined
	) {
		const queryData = {
			tenantId: tenantConfig.tenantId,
			onlyActive,
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			showSecretRestaurants
		};
		const url = useNewShopsData ? "/intusr/shops" : "/shops";
		return getShopsApi(useNewShopsData).get(url, {
			headers: {
				...createHeader({ authToken }),
				["X-TenantId"]: tenantConfig.tenantId
			},
			params: queryData
		});
	},

	findOne(
		id,
		{
			authToken,
			useNewShopsData = isNestBackend()
		}
	) {
		const queryData = {
			tenantId: tenantConfig.tenantId
		};

		const url = useNewShopsData ? "/intusr/shops" : "/shops";

		return getShopsApi(useNewShopsData).get(`${url}/${id}`, {
			headers: createHeader({ authToken }),
			params: queryData
		});
	},


	findOneAdmin(id, { authToken }) {
		const queryData = {
			tenantId: tenantConfig.tenantId
		};

		return getShopsApi(true).get(`/intadm/shops/${id}`, {
			headers: createHeader({ authToken }),
			params: queryData
		});
	},

	update(id, data, { authToken, jwtToken, useNewShopsData = isNestBackend() }) {
		const queryData = {
			tenantId: tenantConfig.tenantId,
			shopId: id
		};
		const token = authToken !== undefined ? authToken : jwtToken;
		const url = useNewShopsData ? `/intadm/shops/${id}` : `/shops/${id}`;

		return getShopsApi(useNewShopsData)[useNewShopsData ? "patch" : "put"](url, data, {
			headers: createHeader({authToken: token}),
			params: queryData
		});
	},

	updateCurrentShopApiData(jwtToken) {
		return getShopsApi(isNestBackend()).get(`/shop-admin/updateFromApi`, {
			params: {
				tenantId: tenantConfig.tenantId
			},
			headers: createHeader({
				authToken: jwtToken
			})
		});
	},

	async getLoggedWithApiData(jwtToken) {
		const response = await getShopsApi(isNestBackend()).get(`/shop-admin/loggedWithApiData`, {
			headers: createHeader({
				authToken: jwtToken
			})
		});

		return response.data;
	},

	async insertShop(data, jwtToken) {
		const response = await getShopsApi(isNestBackend()).post("/shops/", data, {
			headers: createHeader({
				authToken: jwtToken
			})
		});
		return response.data;
	}
};

export default Object.freeze(ShopsProvider);
